import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Form, Button, Grid, Input, TextArea } from 'semantic-ui-react';
import Executives from '../dropdown/executive';
import ReadCookie from '../../functions/readcookies';
import $ from "jquery";
import Server from '../../functions/server';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Add extends React.Component {

  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  update(type, value, fulldata) {
    this.setState({ executive: value })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit = () => {
    let context = this;
    let executive = this.state.executive;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let title = this.state.title;
    let content = this.state.content;
    if (content == '' || content == undefined || content == null) {
      alert('Enter content');
      return;
    }
    if (title == '' || title == undefined || title == null) {
      alert('Enter title');
      return;
    }
    if (executive == '' || executive == undefined || executive == null) {
      alert('Select execuive');
      return;
    }
    let url = Server() + 'tickets/insert.php';
    let data1 = { 'content': content, 'title': title, 'assigned_to': executive, 'created_by': userId };
    if (this.props.type == "edit") {
      url = Server() + 'tickets/update.php';
      data1 = { 'content': content, 'title': title, 'assigned_to': executive, 'created_by': userId, 'id': this.props.id }
    }
    $.ajax({
      type: 'POST',
      data: data1,
      url: url,
      success: function(data)
      {
        if (data == 1) {
          context.setState({ open: false });
          context.props.getTickets();
          context.setState({ title: '', content: '', executive: '' })
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  handleClickOpen1() {
    let executive, title, content;
    let data = this.props.data;
    data.map((x) => {
      if (x.id == this.props.id) {
        executive = x.assigned_to;
        title = x.title;
        content = x.content;
      }
    })
    this.setState({
      open: true,
      title: title,
      content: content,
      executive: executive
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        { (this.props.type == 'add') ?
          (
            <Buttons variant="outlined" style={{display: this.props.ticketeditcontrol}}
              color="primary" onClick={this.handleClickOpen}>
              Create Ticket
            </Buttons>
          ) :
          (
            <div onClick={this.handleClickOpen1.bind(this)}
                 style={{cursor: 'pointer', display: this.props.ticketeditcontrol}}>
                 Edit
            </div>
          )
        }

        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth} open={this.state.open}
          onClose={this.handleClose} aria-labelledby="max-width-dialog-title" >
          <DialogTitle id="max-width-dialog-title">{this.props.title}</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} computer={8} tablet={16}>
                Title<br/>
                <Input placeholder='Title' fluid value={this.state.title} style={{fontSize: 11}} onChange={this.handleChange('title')} />
              </Grid.Column>
              <Grid.Column mobile={16} computer={8} tablet={16}>
                Set Executive<br/>
                { (this.props.type == 'add') ?
                  (
                    <Executives update={this.update.bind(this)} />
                  ) :
                  (
                    <Executives update={this.update.bind(this)} type='set' executive={this.state.executive}  />
                  )
                }

              </Grid.Column>
              <Grid.Column mobile={16} computer={16} tablet={16}>
                Content<br/>
                <Form>
                  <TextArea value={this.state.content} onChange={this.handleChange('content')} />
                </Form>
              </Grid.Column>
            </Grid><br/>
            <Button primary onClick={this.submit}>Submit</Button>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Add.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Add);
